import { useCallback, useEffect, useState } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';

import { useMytaverse } from '@providers/MytaverseProvider';
import ConfirmModal from '@components/ConfirmModal';
import { LogoutReasonEnum } from '@interfaces/user';

const LogoutNotificationModal = ({ t: translate }: WithTranslation) => {
  const { isLogoutForced, logoutUser } = useMytaverse();

  const [open, setOpen] = useState(false);

  const handleConfirm = useCallback(() => {
    setOpen(false);
    logoutUser();
  }, []);

  useEffect(() => {
    setOpen(!!isLogoutForced);
  }, [isLogoutForced]);

  if (!isLogoutForced) {
    return null;
  }

  const renderModal = () => {
    switch (isLogoutForced.reason) {
      case LogoutReasonEnum.UNAUTHORISED:
        return (
          <ConfirmModal
            title={translate('login.accessDenied')}
            message={translate(`login.${isLogoutForced.messageCode}`)}
            onConfirm={handleConfirm}
            open={open}
          />
        );
      case LogoutReasonEnum.SESSION_EXPIRED:
        return (
          <ConfirmModal
            title={translate('login.sessionExpired')}
            message={translate(`login.${isLogoutForced.messageCode}`)}
            onConfirm={handleConfirm}
            open={open}
          />
        );
      case LogoutReasonEnum.SUPPORT:
        return (
          <ConfirmModal
            icon={<PriorityHighIcon />}
            message={translate(`notifications.${isLogoutForced.messageCode}`)}
            onClose={() => {
              setOpen(false);
            }}
            open={open}
          />
        );
      default:
        return null;
    }
  };

  return renderModal();
};

export default withTranslation()(LogoutNotificationModal);
